// Libraries
import React from 'react';
import { Formik } from 'formik';
// Components
import { Button } from '@components/button';
import { CheckBox } from '@components/input';
import { Modal } from '@components/modal';
// Models
import { IModalTermsConditions } from '../models/ModalConditionsProps';
// Constants
import { NOMINA_EN_LINEA_PRODUCT, TypeDocumentNames } from '@constants/Onboarding';
// Assets
import logo from '@assets/logos/logo-nav-green.png';
import './termsAndConditionsModal.scss';

export const ModalTermsConditions: React.FC<IModalTermsConditions> = ({
    showErrorMessage,
    handleOpenDocument,
    handleSubmitTermsConditions = (): void => {},
    handleBackFunction = (): void => {},
}) => {
    return (
        <Formik initialValues={{ terms_conditions: false }} onSubmit={(): void => {}}>
            {({ values }): JSX.Element => (
                <Modal isOpen closeIcon={false} className="modal-term">
                    <div className="modal-term__container">
                        <img src={logo} className="image-width" />
                        <div className="modal-term__container--text">
                            {showErrorMessage ? (
                                <>
                                    No fue posible registrar tu aceptación de Términos y Condiciones en este momento. Intenta
                                    nuevamente.
                                </>
                            ) : (
                                <> Para continuar en nuestra plataforma lee y acepta nuestros Términos y Condiciones</>
                            )}
                        </div>
                        <div className="modal-term__container--check">
                            <div>
                                <CheckBox name="terms_conditions" />
                            </div>
                            <div>
                                He leído y acepto los &nbsp;
                                <span
                                    onClick={(): void =>
                                        handleOpenDocument(TypeDocumentNames.TERMS_CONDITIONS, NOMINA_EN_LINEA_PRODUCT)
                                    }
                                >
                                    Términos y Condiciones
                                </span>
                            </div>
                        </div>
                        <div className="modal-term__button-container">
                            <Button onClick={handleBackFunction}>Volver</Button>
                            <Button onClick={handleSubmitTermsConditions} disabled={!values.terms_conditions}>
                                Aceptar
                            </Button>
                        </div>
                    </div>
                </Modal>
            )}
        </Formik>
    );
};
